import React from 'react'

export default function Media() {
  return (
    <div>
        

   <h2 style={{textAlign : 'center'}} >Listen Music Here !!</h2>

<br />


<div style={{display : 'flex' , justifyContent : 'center' , flexWrap : 'wrap'}} >

<iframe style={{borderRadius: '12px' , width : '40%' , height : '380' , frameBorder : '0' , marginRight : '20px'}} src="https://open.spotify.com/embed/playlist/37i9dQZF1DX9sIqqvKsjG8?utm_source=generator"  allowfullscreen="" allow=" ; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>


<iframe style={{borderRadius: '12px' , width : '40%' , height : '380' , frameBorder : '0' , allowfullscreen :"" , allow : "; clipboard-write; encrypted-media; fullscreen; picture-in-picture"}} src="https://open.spotify.com/embed/playlist/37i9dQZF1DX0XUfTFmNBRM?utm_source=generator"  ></iframe>

<iframe style={{borderRadius: '12px' , width : '40%' , height : '380' ,  marginRight : '20px' , frameBorder : '0' , allowfullscreen :"" , allow : "; clipboard-write; encrypted-media; fullscreen; picture-in-picture"}} src="https://open.spotify.com/embed/playlist/37i9dQZF1DX5trt9i14X7j?utm_source=generator"></iframe>

<iframe style={{borderRadius: '12px' , width : '40%' , height : '380' , frameBorder : '0' , allowfullscreen :"" , allow : "; clipboard-write; encrypted-media; fullscreen; picture-in-picture"}} src="https://open.spotify.com/embed/playlist/37i9dQZF1DX3rxVfibe1L0?utm_source=generator" ></iframe>
 
</div>

<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />



    </div>
  )
}
